import { gql } from '../__generated__'

export const GET_COMMENT_LIKED_BY = gql(`
  query GetCommentLikedBy($id: UUID!) {
    getComment(commentId: $id) {
      likedBy {
        ...AccountFragment
      }
    }
  }
`)

export const GET_COMMENT_RESOURCES = gql(`
  query GetCommentResources($id: UUID!) {
    getComment(commentId: $id) {
      id
      resources {
        ...ResourceFragment
      }
    }
  }
`)

export const MY_TASKS = gql(`
  query MyTasks($input: MyTasksInput) {
    myTasks(input: $input) {
      tasks {
        ...MyTaskFragment
      }
      meta {
        ...PaginationMetadataFragment
      }
    }
  }
`)

export const DASHBOARD_TASKS = gql(`
  query DashboardTasks($input: MyTasksInput) {
    myTasks(input: $input) {
      tasks {
        ...DashboardTaskFragment
      }
      meta {
        ...PaginationMetadataFragment
      }
    }
  }
`)

export const GET_RECURRING_DEFINITION = gql(`
  query GetRecurringDefinition($input: RecurringDefinitionIdInput) {
    getRecurringDefinition(input: $input) {
      ...RecurringTaskDefinitionFragment
    }
  }
`)

export const GET_RECURRING_DEFINITION_TASKS = gql(`
  query GetForRecurring($input: GetForRecurringInput) {
    getForRecurring(input: $input) {
      tasks {
        id
        rootTaskId
        parentTaskId
        type
        parentEntityType
        project {
          id
          name
        }
        milestone {
          id
          name
        }
        recurringId
        owner {
          ...AccountFragment
        }
        assignees {
          ...AccountFragment
        }
        name
        status
        deadline {
          seconds
        }
        executionDate {
          seconds
        }
      }
      meta {
        ...PaginationMetadataFragment
      }
    }
  }
`)

export const GET_TASK_DETAILS_COUNTERS = gql(`
  query GetTaskDetailsCounters($id: UUID!) {
    getTaskDetailsCounters(id: $id) {
      ...TaskDetailsCountersFragment
    }
  }
`)

export const GET_LOGGED_TIMES = gql(`
  query GetLoggedTimes($input: GetTaskInput!) {
    getLoggedTimes(input: $input) {
      ...LoggedTimeFragment
    }
  }
`)

export const GET_TASK_RESOURCES = gql(`
  query GetTaskResources($input: GetTaskInput!) {
    getTask(input: $input) {
      id
      resources {
        ...ResourceFragmentWithEntityNames
      }
    }
  }
`)

export const GET_TASK_INFO = gql(`
  query GetTaskInfo($input: GetTaskInput!) {
    getTask(input: $input) {
      id
      name
      milestone {
       id
      }
      goal {
       id
      }
      owner {
        ...AccountFragment
      }
    }
  }
`)
